import { render, staticRenderFns } from "./fccUploadProvas.vue?vue&type=template&id=103ef92d"
import script from "./fccUploadProvas.vue?vue&type=script&lang=js"
export * from "./fccUploadProvas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports